<template>
  <v-container class="pt-0 px-3 grid-list-xs">
    <v-layout style="padding-left: 60px;">
      <div v-for="act in activity.activities" :key="act.id" class="pr-1">
        <nuxt-link :to="localePath('/' + act.object.to_person.__str__ + '/')">
          <v-avatar>
            <img
              v-lazy="
                act.object.to_person.source ||
                  $store.state.placeholder.avatar_sm
              "
              :alt="act.object.to_person.display_name"
            />
          </v-avatar>
        </nuxt-link>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    activity: {
      type: [Object],
      required: true,
      default: () => ({})
    }
  }
}
</script>
